import React, { memo } from 'react';
import { CheckCircle2 } from 'lucide-react';
export function MethodSection() {
  const items = [{
    title: 'Contexto productivo primero.',
    desc: 'El técnico no memoriza definiciones. Resuelve problemas reales de granja.'
  }, {
    title: 'Especies y sistemas de nuestra región.',
    desc: 'Trucha en el sur, tilapia y pacú en el norte, camarón en la costa. Lo que tus alumnos van a manejar realmente en el campo.'
  }, {
    title: 'Del aula al campo.',
    desc: 'Cada módulo incluye actividades para el laboratorio, la visita de campo o simulación en el aula.'
  }];
  return <section className="py-7 px-4 bg-brand-navy text-white" data-id="element-120">
      <div className="max-w-4xl mx-auto text-center" data-id="element-121">
        <p className="text-brand-orange font-display font-bold uppercase text-sm tracking-widest mb-2" data-id="element-122">
          ✨ El Método
        </p>
        <h2 className="text-2xl md:text-4xl font-display font-bold uppercase leading-tight mb-5" data-id="element-123">
          "Técnico <span className="text-brand-orange" data-id="element-124">Aplicado</span>"
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-125">
          {items.map((it, i) => <div key={i} className="bg-white text-brand-ink rounded-lg p-4 border-b-4 border-brand-green text-left" data-id="element-126">
              <CheckCircle2 className="w-6 h-6 text-brand-green mb-2" data-id="element-127" />
              <h3 className="font-display text-base md:text-lg text-brand-navy uppercase font-bold mb-1 leading-tight" data-id="element-128">
                {it.title}
              </h3>
              <p className="text-sm text-brand-mute leading-snug font-medium" data-id="element-129">
                {it.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}